export const LOG_MOVE_DISTANCE = 56;
export const LAST_LOAD_MIN_SPAN = 1500;
